
/*=========================================================================================
  File Name: modulekaindsGetters.js
  Description: kainds Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  getTelephone: state => (id) => state.telephones.find(telephone => telephone.id === id),
  getTelephones: state => state.telephones,
  listTelephoneFolder: state => state.telephoneFolders
}
